import { Pipe, PipeTransform } from '@angular/core';
import { IAddressData } from '@df/session/api/address-book/address';

@Pipe({
    name: 'customerName',
    standalone: true
})
export class CustomerNamePipe implements PipeTransform {
    transform(addressData: IAddressData) {
        if (addressData) {
            return [addressData.prefix, addressData.firstname, addressData.lastname].filter(i => !!i).join(' ');
        }
        return '';
    }
}
